import api from '@/api';
import { API_BASE_URL } from '..';
import {
  CreateDeduction,
  DeductionEditRequest,
  Deductions,
  UpdateDeduction,
} from './Deduction.types';

const CONTROLLER_URL = `${API_BASE_URL}/invoices`;

export async function deductions(invoiceId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${invoiceId}/deductions`,
    null,
  )) as unknown;

  return result as Deductions[];
}

export async function editDeduction(obj: DeductionEditRequest) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${obj.invoiceId}/deductions/${obj.id}`,
    null,
  )) as unknown;

  return result as Deductions;
}

export async function createDeduction(obj: CreateDeduction) {
  const { invoiceId, ...values } = obj;

  const result = (await api.post(
    `${CONTROLLER_URL}/${invoiceId}/deductions`,
    values,
    null,
  )) as unknown;

  return result;
}

export async function updateDeduction(obj: UpdateDeduction) {
  const { invoiceId, id, ...values } = obj;

  const result = (await api.put(
    `${CONTROLLER_URL}/${invoiceId}/deductions/${id}`,
    values,
    null,
  )) as unknown;

  return result;
}

export async function deleteDeduction(obj: DeductionEditRequest) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${obj.invoiceId}/deductions/${obj.id}`,
    {},
    null,
  )) as unknown;

  return result;
}
